import React from 'react';
import Icon from 'antd/lib/icon';
import classNames from 'classnames';

import { additionsClasses } from '../../../utils';

import style from './Icons.module.scss';
import svgIcons from './svgIcons';


export const CustomIcon = ({ svg, additions, vendorClass, svgProps, children, ...props }) => {
  let SvgCmp = null;

  if (svg) {
    const SvgIcon = svgIcons[svg];
    SvgCmp = SvgIcon
      ? {
        component: () => <SvgIcon { ...svgProps } />
      }
      : {
        type: svg
      };
  }

  return svg
    ? (
      <>
        <Icon
          data-testid="icon"
          { ...props }
          className={ classNames(style.Icon, additionsClasses(additions, style), vendorClass) }
          { ...SvgCmp }
        />
        {children}
      </>
    )
    : (
      <>
        <Icon
          data-testid="icon"
          { ...props }
          className={ classNames(style.Icon, additionsClasses(additions, style), vendorClass) }
        />
        {children}
      </>
    );
};
